import { TextField } from '@app/components/form-fields/TextField';
import type { AIAgentListParams } from '@app/services/agent.types';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';
import { MdSearch } from 'react-icons/md';

export type AiAgentFiltersProps = {
    onChange: (values: AIAgentListParams) => void;
};

export const AiAgentFilters = ({ onChange }: AiAgentFiltersProps) => {
    const [filterSelection, setFilterSelection] = useState<AIAgentListParams>({
        search: '',
        page: 1,
        per_page: 10,
    });

    useEffect(() => {
        onChange(filterSelection);
    }, [filterSelection]);

    return (
        <div>
            <TextField
                placeholder="Search AI Agents..."
                prefix={<MdSearch size={20} />}
                onChange={debounce((e) => {
                    setFilterSelection((prev) => ({
                        ...prev,
                        search: e.target.value,
                    }));
                }, 500)}
            />
        </div>
    );
};

export default AiAgentFilters;
